import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core';
import { DocumentNode } from '@completion/models';
import { NodeType } from '@completion/enums';
import { NodeFactoryService } from '../../node-factory.service';

@Component({
  selector: 'app-document-node-view',
  templateUrl: './document-node-view.component.html',
  styleUrls: ['./document-node-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentNodeViewComponent {
  @Input() node: DocumentNode;
  NodeType = NodeType;

  constructor(
    public nodeFactory: NodeFactoryService,
    private injector: Injector,
  ) {}

  createInjectorForNode() {
    // Pass null for the full procedure document when not available in this context
    return this.nodeFactory.createInjector(this.node, null, this.injector);
  }
}
